import { axiosRef } from '../../../api';
import { lmsOnHandReportPayload } from '../interfaces';

export default async function getLmsOnHandReport(
  payload: lmsOnHandReportPayload,
  isAdmin: boolean,
  setLoading: (loading: boolean) => void,
) {
  setLoading(true);

  let url = `/business_central/lms/report/on_hand?`;

  if (payload && payload.fileType) {
    url = url + `&report_type=${payload.fileType}`;
  }

  if (payload && payload?.locationCode) {
    url = url + `&location_code=${payload.locationCode}`;
  }

  if (payload && payload?.destinationCode) {
    url = url + `&destination_location_code=${payload.destinationCode}`;
  }

  if (isAdmin && payload && payload?.jobNo) {
    url = url + `&job_no=${payload.jobNo}`;
  }

  try {
    const response = await axiosRef.get(url);

    if (!response?.data?.is_error) {
      setLoading(false);
      const report = response.data.content;
      return {
        report,
      };
    }
    setLoading(false);
    return {
      report: null,
    };
  } catch (error) {
    setLoading(false);
    return {
      report: null,
    };
  }
}
